import { IPC_EVENT } from "../ipc_events";
import BookData from "./book_data";
import UserData from "./user_data";
import { useUserStore } from "./user_data";
import AppReceiver from "./app_receiver";
import EventBus from "./event_bus";
import VersionManager from './check_version/check_version';
import { store } from "../store";
import { VIEW_TYPE } from "./view_type";
import SystemData from "./system_data";
import screenfull from 'screenfull';

export default class AppRenderer {

    /**
     *
     * @type {AppRenderer}
     * @memberof AppRenderer
     */
    static _instance = null;


    static get Instance() {
        if (this._instance == null) {
            this._instance = new AppRenderer();
        }

        return this._instance;
    }

    receiver = null;
    nowView = VIEW_TYPE.PC;

    constructor() {
        this.nowView = store.nowView;
        switch (this.nowView) {
            case VIEW_TYPE.PC:
            case VIEW_TYPE.MAC:
                window.ipcRenderer.receive(IPC_EVENT.GET_PLATFORM, (platform) => {
                    SystemData.Instance.setPlatform(platform);
                })
                window.ipcRenderer.receive(IPC_EVENT.GET_APP_PATH, (appPath) => {
                    BookData.Instance.setAppPath(appPath);
                })

                window.ipcRenderer.receive(IPC_EVENT.RETURN_BOOK_PATH, (path) => {
                    BookData.Instance.setBookPath(path);
                    BookData.Instance.loadBookConfig();
                    BookData.Instance.loadBookVersion();
                    VersionManager.Instance.setCurrentVersion();
                    window.app.$refs.directory.getDirectoryData();
                })

                window.ipcRenderer.receive(IPC_EVENT.EXIT, () => {
                    EventBus.getInstance().emit("save_record");
                })

                this.receiver = AppReceiver.Instance;
                this.receiver.renderer = this;
                break;
            default:
                break;
        }
    }

    /**
     *
     * 外開應用程式, 本機網頁
     * @param {string} fileName
     * @memberof AppRenderer
     */
    openFile(fileName, closeSelf = false) {
        window.ipcRenderer.send(IPC_EVENT.OPEN_EXE, fileName, closeSelf);
    }

    /**
     *
     * 開啟一般網頁 檔案路徑帶http:// 或是 https://
     * @param {string} websitePath
     * @memberof AppRenderer
     */
    openWebSite(websitePath) {
        window.ipcRenderer.send(IPC_EVENT.OPEN_WEB_SITE, websitePath);
    }

    getPath(name) {
        window.ipcRenderer.send(IPC_EVENT.GET_PATH, name);
    }

    /**
     *
     * 取得相同紀錄檔名的Id，檢查檔名重複使用
     * @param {string} logName
     * @memberof AppRenderer
     */
    getRepeatRecordId(logName) {
        const USER_DATA = useUserStore();
        window.ipcRenderer.send(IPC_EVENT.CHECK_LOG_NAME_REPEAT, BookData.Instance.BookId, USER_DATA.userId, logName);
    }

    /**
     *
     * 建立新的紀錄檔
     * @param {String} logName 記錄檔檔名
     * @param {JSON} data 紀錄
     * @param {String} savePath 存檔路徑
     * @memberof AppRenderer
     */
    saveRecord(logName, data, savePath) {
        if (savePath) {
            // 另存新檔
        } else {
            // 本機檔案
            const USER_DATA = useUserStore();
            window.ipcRenderer.send(IPC_EVENT.ADD_USER_RECORD, BookData.Instance.BookId, USER_DATA.userId, logName, data);

        }
    }
    /**
     * 更新使用者紀錄
     * @param {String} uuid 紀錄的uid
     * @param {*} data 存檔資料
     */
    updateRecord(uuid, data) {
        window.ipcRenderer.send(IPC_EVENT.UPDATE_USER_RECORD, uuid, data);
    }
    /**
     * 另存使用者紀錄
     * @param {*} data 
     */
    saveAsRecord(data, defaultName) {
        window.ipcRenderer.send(IPC_EVENT.SELECT_SAVE_NEW_FILE_PATH, data, defaultName);
    }
    /**
     * 查詢使用者紀錄
     */
    getUserRecord() {
        const USER_DATA = useUserStore();
        window.ipcRenderer.send(IPC_EVENT.GET_USER_RECORD, BookData.Instance.BookId, USER_DATA.userId);
    }
    detectRecordFolder() {
        window.ipcRenderer.send(IPC_EVENT.DETECT_RECORD_FOLDER, BookData.Instance.BookId)
    }
    /**
     * 關閉閱讀器
     */
    exit() {
        window.ipcRenderer.send(IPC_EVENT.EXIT);
    }
    /**
     * 切換全螢幕或是視窗狀態
     */
    switchFullScreenOrWindow() {
        if (store.nowView == VIEW_TYPE.WEB) {
            if (!/iPhone/i.test(navigator.userAgent)) {
                screenfull.toggle();
            }
        } else {
            window.ipcRenderer.send(IPC_EVENT.SWITCH_FULLSCREEN_WINDOW);
        }
    }

    /**
     * 開啟其他紀錄
     *
     * @memberof AppRenderer
     */
    selectOtherRecord() {
        window.ipcRenderer.send(IPC_EVENT.SELECT_OTHER_RECORD);
    }
    /**
     * 儲存記錄檔
     * @param {String} logName 
     * @param {String} data 
     */
    saveCloudRecord(logName, updateTime, data) {
        const USER_DATA = useUserStore();
        window.ipcRenderer.send(IPC_EVENT.ADD_CLOUD_USER_RECORD_TO_LOCAL, BookData.Instance.BookId, USER_DATA.userId, logName, updateTime, data);
    }
    /**
     * 
     * @param {String} logId 
     * @param {String} updateTime 
     * @param {*} data 
     */
    updateCloudRecord(logId, updateTime, data) {
        window.ipcRenderer.send(IPC_EVENT.UPDATE_CLOUD_USER_RECORD_TO_LOCAL, logId, updateTime, data);
    }
    /**
     * 
     * @param {String} logId 
     * @param {String} logName 
     * @param {String} filePath 
     * @param {String} updateTime 
     */
    deleteRecord(logId, logName, filePath, updateTime) {
        window.ipcRenderer.send(IPC_EVENT.DELETE_USER_RECORD, logId, logName, filePath, updateTime);
    }
    /**
     * 開始單一入口登入
     */
    startSingleLogin() {
        window.ipcRenderer.send(IPC_EVENT.SINGLE_LOGIN);
    }
    finishSingleLogin() {
        window.ipcRenderer.send(IPC_EVENT.SINGLE_LOGIN_FINISH);
    }

    setBookId(bookId) {
        window.ipcRenderer.send(IPC_EVENT.SET_BOOK_ID, bookId);
    }
    /**
     * 複製圖片到tempFolder中，修改圖片名稱使其不會重複
     * @param {Object} file 
     * @param {String} path
     */
    getCopiedImage(file) {
        window.ipcRenderer.send(IPC_EVENT.GET_COPIED_IMAGE, file, file.path);
    }
    /**
     * 複製圖片到tempFolder中
     * @param {String} src 
     */
    copyImage(src) {
        window.ipcRenderer.send(IPC_EVENT.COPY_IMAGE, src);
    }

    openWebPageInSubWindow(src) {
        window.ipcRenderer.send(IPC_EVENT.OPEN_WEB_PAGE_IN_SUB_WINDOW, src);
    }

    loadRecord(src) {
        window.ipcRenderer.send(IPC_EVENT.LOAD_RECORD, src);
    }

    saveImage(bookId, recordName, imageName, data) {
        window.ipcRenderer.send(IPC_EVENT.SAVE_IMAGE, bookId, recordName, imageName, data);
    }

    removeImage(imageName) {
        console.log('removeImage', imageName)
        window.ipcRenderer.send(IPC_EVENT.REMOVE_IMAGE, imageName);
    }

    backToBookcase() {
        window.ipcRenderer.send(IPC_EVENT.BACK_TO_BOOKCASE);
    }

    autoSaveLocal(data) {
        window.ipcRenderer.send(IPC_EVENT.AUTO_SAVE_LOCAL, BookData.Instance.BookId, data);
    }
}